export enum SOURCE_CHANNEL {
    POP_SHELL_APP = "pop-shell-app",
    TOING_APP = "toing-app",
    IXIGO = "ixigo-app",
    JIO_HOTSTAR = "jiohotstar",
}

export enum SHELL_APP_DEEPLINK_PREFIX {
    TOING_APP = "toing://",
    BASE = "swiggy://",
}
